import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { ApplicationConfig } from '../../config/config';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  constructor(
    private storeService: ErrorMessagesReducerStoreService,
    private http: HttpClient,
    private config: ApplicationConfig,
    private loggingService: LoggingService
  ) {}

  loadErrorMessages(): void {
    this.http.get(`${this.config.get('APP_MESSAGES_ERROR_URL')}`).subscribe(
      (data) => {
        this.storeService.loadDetails(data);
      },
      (err) => {
        this.loggingService.log('Caught Error: ' + err);
      }
    );
  }
}
